export const getGroupJoinTitle = groupOrderAdmin => {
  const name = groupOrderAdmin || 'Group Admin';
  return `Join ${name}'s Group Order`;
};

export const getGroupJoinCTALabel = groupOrderAdmin => {
  const name = groupOrderAdmin || 'Group Admin';
  return `Start Ordering with ${name}`;
};

export const getGroupOrderJoinLeaveTitle = groupOrderAdmin => {
  const name = groupOrderAdmin || 'Group Admin';
  return `Are you sure you want to leave ${name}'s Group Order?`;
};

export const getGroupOrderJoinLeaveContinueLabel = groupOrderAdmin => {
  const name = groupOrderAdmin || 'Group Admin';
  return `Continue Ordering with ${name}`;
};
